import { ICustomer } from './customer.types.js'

export enum LANG {
  EN_US = 'en-US',
  SV_SE = 'sv-SE',
}

export interface IUser {
  email: string
  password?: string
  hasCreatedPassword: boolean
  fullName?: string
  phone?: string
  lastLoggedIn?: Date
  blocked: boolean
  numberOfFailedLogins: number
  permissions?: UserPermission
  permissionsV2: UserPermissionV2[]
  customerId: ICustomer | string
  lang?: LANG
}

export interface UserBM extends IUser {
  _id: string
}

export type UserPermission = 'admin' | 'editor' | 'viewer'
export enum UserPermissionV2 {
  ADMIN = 'admin',
  SELF = 'self',
}
